
namespace GeniuzPOS.Purchase {
    import fld = PoPurRequestRow.Fields;
    @Serenity.Decorators.registerClass()
    export class PoPurRequestGrid extends Serenity.EntityGrid<PoPurRequestRow, any> {
        protected getColumnsKey() { return PoPurRequestColumns.columnsKey; }
        protected getDialogType() { return PoPurRequestDialog; }
        protected getIdProperty() { return PoPurRequestRow.idProperty; }
        protected getInsertPermission() { return PoPurRequestRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurRequestRow.localTextPrefix; }
        protected getService() { return PoPurRequestService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
      

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };
            Q.first(filters, x => x.field == fld.CreateBy).init = w => {
                var userId = Authorization.userDefinition.Username;
                // console.log(Authorization.userDefinition.Username);
                // console.log(userId);
                (w as Serenity.LookupEditor).value = userId;
            };

            return filters;
        }

        protected getButtons() {
            const buttons = super.getButtons();
            
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PoPurRequestService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
    
            buttons.push({
                title: "Import From Excel",
                hint: "Import PR from Excel template",
                cssClass: "upload-pr-template-button",
                icon: "fa-cloud-upload-alt",
                separator: true,
                onClick: () => {
                    const dialog = new ImportPrDialog()
                    this.initDialog(dialog)
                    dialog.importState = () => {
                        Q.notifySuccess("Import from Excel successfully.")
                        this.refresh()
                    }
    
                    dialog.dialogOpen()
                }
            });

            buttons.push({
                title: "Download Template",
                hint: "Download Excel template for PR import",
                cssClass: "download-PR-template-button",
                icon: "fa-download",
                separator: true,
                onClick: () => {
                    window.location.href = Q.resolveUrl("~/Services/Csi/DownloadImportPRTemplate");
                }
            });

            
    
            return buttons
        }

    }
}